// Generated by scripts/build.js from package.json. Do not edit by hand.
export const name = 'nodemailer';
export const version = '10.0.3';
export const homepage = 'https://nodemailer.com/';
